<style lang="scss">
.pagination {
  justify-content: flex-end !important;
  .page-stats {
    align-items: center;
    margin-right: 5px;
  }
  i {
    color: #3273dc !important;
  }
}
select.selectable {
  width: 20px;
}
</style>

<template>
  <div class="v-datatable v-table theme--light">
    <div class="v-datatable__actions">
      <div class="v-datatable__actions__select">
        Rows per page:
        <div role="combobox" class="v-input v-text-field v-select v-input--hide-details v-input--is-label-active v-input--is-dirty theme--light">
          <div class="v-input__control">
            <div class="v-input__slot">
              <div class="v-select__slot">
                <div class="v-select__selections">
                </div>
              </div>
              <div class="v-menu">
                <select v-model="tableData.length" @change="$emit('getItems');" class="selectable">
                  <option v-for="(records, index) in perPage" :key="index" :value="records">{{records}}</option>
                </select>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="v-datatable__actions__range-controls">
        <div class="v-datatable__actions__pagination">{{pagination.from}} - {{pagination.to}} of {{pagination.total}}</div>
        <button type="button" class="v-btn v-btn--flat v-btn--icon theme--light" aria-label="Previous page" :disabled="pagination.links.previous ? false : true" @click="$emit('prev');">
          <div class="v-btn__content"><i aria-hidden="true" class="v-icon material-icons theme--light">chevron_left</i></div>
        </button>
        <button type="button" class="v-btn v-btn--flat v-btn--icon theme--light" aria-label="Next page" :disabled="pagination.links.next ? false : true" @click="$emit('next');">
            <div class="v-btn__content"><i aria-hidden="true" class="v-icon material-icons theme--light">chevron_right</i></div>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['pagination', 'tableData', 'filtered', 'perPage']
}
</script>



// WEBPACK FOOTER //
// src/components/shared/Pagination.vue